import { CONTACT_STATUS_CODE_MAPPINGS } from '@/types';

export const SUPPORTER_STATUSES_WITH_IDS = [
  { id: 'P'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.P },
  { id: 'C'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.C },
  { id: 'X'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.X },
  { id: 'N'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.N },
  { id: 'D'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.D },
  { id: 'S'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.S },
  { id: 'R'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.R },
  { id: 'O'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.O },
  { id: 'U'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.U },
  { id: 'A'.codePointAt(0)!, label: CONTACT_STATUS_CODE_MAPPINGS.A },
];
